import React from 'react';
import PropTypes from 'prop-types';

import MediaQuery from 'react-responsive';

export default function LargeMedia(props) {
  return (
    <MediaQuery minDeviceWidth={768}>
      {(matches) => {
        if (matches) {
          return props.children || null;
        }
        return null;
      }}
    </MediaQuery>
  );
}

LargeMedia.propTypes = {
  children: PropTypes.node.isRequired
};
